<script setup lang="ts">
import type { HTMLAttributes, LabelHTMLAttributes } from 'vue'

const props = defineProps<{
  class?: HTMLAttributes['class']
  label?: string
  required?: boolean
  for?: LabelHTMLAttributes['for']
}>()
</script>

<template>
  <div :class="cn('flex flex-col gap-1', props.class)">
    <label v-if="props.label" :for="props.for" class="text-xs font-medium">
      {{ props.label }}
      <span v-if="required" class="text-error">*</span>
    </label>
    <slot />
  </div>
</template>
